import React, { useContext, useEffect, useState, useRef } from "react";
import AttendanceSvg from '../svg/AttendanceSvg';
import PageNav from '../components/PageNav';
import Featured from '../components/Featured';
import Card from '../components/common/Card';
import classNames from 'classnames';
import { Link } from 'react-router-dom'
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import Attendance from './Attendance';
import useOnClick from '../components/common/ClosePopUp';
import loadingSpin from '../images/loadingSpin.gif';
import { toTitleCase } from '../util/titleCase';
import { animated, useSpring } from "react-spring";
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const VirtualClassroom = () => {
    const authContext = useContext(AuthContext);
    const [displayDropdown, setDisplayDropdown] = useState(false);
    const [displayTermDropdown, setDisplayTermDropdown] = useState(false);
    const [clickedSession, setClickedSession] = useState("All sessions");
    const [clickedTermDropdown, setClickedTermDropdown] = useState("All terms");
    const [allTerms, setAllTerms] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [sessionAttendance, setSessionAttendance] = useState([{year : "All sessions"}]);
    const [sessionTerms, setSessionTerms] = useState([{term : "All terms"}]);
    const [loading, setLoading] = useState(false)

    const studentInfo = JSON.parse(localStorage.getItem('studentInfo'));
    const admissionnumber = studentInfo[0].admissionnumber;
    // const schoolDomain = window.location.host;
    const schoolDomain = localStorage.getItem('schoolDomain');
    const deploymentIdx = JSON.parse(localStorage.getItem('subSchoolData')).idx;


    const [ fetchedAllAttendance, setfetchedAllAttendance] = useState([]);

    const sessionRef = useRef();
    const termRef = useRef();

    useOnClick(sessionRef, () => setDisplayDropdown(false));
    useOnClick(termRef, () => setDisplayTermDropdown(false));

    useEffect(() => {
        const queryData = {
            // admissionnumber : 'PHY105',
            admissionnumber,
            SchoolUrl : schoolDomain,
            deploymentIdx : deploymentIdx,
            // SchoolUrl : 'demo.edves.net',
            // preferedTerm : clickedTermDropdown === 'First Term' ? 'FIRST TERM' : clickedTermDropdown === 'Second Term' ? 'SECOND TERM' : clickedTermDropdown === '3rd Term' ? 'THIRD TERM' : ''
        };
        const getAllAttendance = async () => {
            try {
                setLoading(true)
                const { data } = await axios.post(`${authContext.baseUrl}/student/attendancesummary`, queryData);
                if(!data.status) {
                    setLoading(false);
                    setAllTerms(false);
                    setErrorMessage(data.message);
                    // console.log(data.message);
                } else {
                    setAllTerms(true);
                    setLoading(false);
                    setfetchedAllAttendance(data.data);
                }
            } catch (error) {
                // console.log(error)
            };
            try {
                setLoading(true)
                const { data } = await axios.get(`${authContext.baseUrl}/getschoolsession/${schoolDomain}`);
                setSessionAttendance( initial => [...initial, ...data.data]);
                // console.log(data.data);
                // console.log(sessionAttendance)
                setLoading(false)
            } catch (error) {
                // console.log('Sessions fetch error', error)
            };
            try {
                setLoading(true)
                const { data } = await axios.get(`${authContext.baseUrl}/getschoolterm/${schoolDomain}`);
                setSessionTerms(initial => [...initial, ...data.data]);
                // console.log(data.data);
                // console.log(sessionTerms);
                setLoading(false)
            } catch (error) {
                // console.log('Terms fetch error', error)
            }
        }
        getAllAttendance();
        return () => {}
    }, [])

    const showDropdown = classNames({
        "hidden" : !displayDropdown,
        "bg-white absolute mt-10 z-10 text-gray-100 leading-4 text-xs border rounded-md border-gray-500" : true
    });

    const showTermDropdown = classNames({
        "hidden" : !displayTermDropdown,
        "bg-white absolute mt-10 z-10 text-gray-100 leading-4 text-xs border rounded-md border-gray-500" : true
    });

    const displaySessions = (session) => {
        setDisplayDropdown(!displayDropdown);
        // console.log(displayDropdown);
        setClickedSession(session.year);
        setDisplayDropdown(!displayDropdown);

        // const queryData = {
        //     admissionnumber : 'PHY105',
        //     SchoolUrl : 'demo.edves.net',
        //     preferedTerm : clickedTermDropdown === 'All terms' ? '' : clickedTermDropdown,
        //     preferedSection : clickedSession === 'All sessions' ? '' : clickedSession 
        // };
        // const getAllAttendance = async () => {
        //     try {
        //         const { data } = await axios.post(`${authContext.baseUrl}/student/attendancesummary`, queryData);
        //         data.status && setAllTerms(true)
        //         setfetchedAllAttendance(data.data)
        //     } catch (error) {
        //         console.log(error)
        //     }
        // }

        // getAllAttendance()
    };

    const displayTerms = (term) => {
        setClickedTermDropdown(term.term);
        // console.log('clicked term~!!!', term.term);
        setDisplayTermDropdown(!displayTermDropdown);

        const queryData = {
            admissionnumber,
            SchoolUrl : schoolDomain,
            // SchoolUrl : 'demo.edves.net',
            preferedTerm : term.term === 'All terms' ? '' : term.term,
            preferedSection : clickedSession === 'All sessions' ? '' : clickedSession ,
            deploymentIdx : deploymentIdx,
        };
        // console.log(queryData)
        const getSearchedAttendance = async () => {
            try {
                setLoading(true)
                const { data } = await axios.post(`${authContext.baseUrl}/student/attendancesummary`, queryData);
                // console.log(data.message);
                if (!data.status) {
                    setAllTerms(false);
                    setErrorMessage(data.message);
                    setLoading(false)
                } else {
                    setAllTerms(true);
                    setLoading(false);
                    setfetchedAllAttendance(data.data);
                }
            } catch (error) {
                // console.log(error)
            }
        }
        getSearchedAttendance();
    
    };

    const Heading = () => (
        <>
            <span className="text-xl mr-4 sm:mr-0 sm:text-2xl leading-7 font-semibold text-white mt-1"> Attendance </span>
        </>
    );

    const pageSvg = () => (
        <>
            <AttendanceSvg />
        </>
    );

    const firstTerm = [
        {
            info: 'School Opened',
            metric: '152 days',
            index: '1'
        },
        {
            info: 'Days Present',
            metric: '144 days',
            index: '2'
        },
        {
            info: 'Days Late',
            metric: '31 days',
            index: '3'
        },
        {
            info: 'Days Absent',
            metric: '8 days',
            index: '4'
        }
    ];

    const secondTerm = [
        {
            info: 'School Opened',
            metric: '155 days',
            index: '1'
        },
        {
            info: 'Days Present',
            metric: '147 days',
            index: '2'
        },
        {
            info: 'Days Late',
            metric: '11 days',
            index: '3'
        },
        {
            info: 'Days Absent',
            metric: '3 days',
            index: '4'
        }
    ];

    const resultTransitionStyle = useSpring({
        to: [
            { opacity: 1, transform: 'translateY(0)' },
        ],
        from: { opacity: 0, transform: 'translateY(-80px)' },
        config: { duration: 1000 }
    });

    const TermOne = () => (
        <>
            <div className="w-full">
                <Card> 
                {fetchedAllAttendance.map((item) => {
                    return (
                    <animated.div style={resultTransitionStyle} className='p-2 sm:p-4'>
                        <div className="flex w-full justify-between items-center">
                            <div className="flex text-gray-200 w-full leading-4">
                                <span className="text-xs sm:text-sm mr-2 sm:mr-4"> {item.year} </span>
                                <span className='text-xs sm:text-sm w-auto sm:w-auto'> {(item.term)}</span>
                            </div>
                            <Link to='/attendance' className="w-32 sm:w-40 bg-blue-900 rounded text-center text-blue-100 text-xs font-semibold py-2 leading-4 flex justify-center">
                                View Attendance
                                <div className='hidden'>
                                    <Attendance fetchedAtt = {item} />
                                </div>
                            </Link>
                        </div>
                        <div className="w-full mt-5 grid grid-cols-2 lg:grid-cols-4 col-gap-3 row-gap-3">
                            <>
                                <div className="flex flex-col justify-between items-center py-4 rounded-md bg-blue-800">
                                    <span className="text-gray-300 text-xs sm:text-sm leading-4"> School Opened </span>
                                    <span className="text-gray-100 text-xs sm:text-sm leading-4 font-semibold mt-3"> {item.schoolOpened} </span>
                                </div>
                                <div className="flex flex-col justify-between items-center py-4 rounded-md bg-green-800">
                                    <span className="text-gray-300 text-xs sm:text-sm leading-4"> Days Present </span>
                                    <span className="text-gray-100 text-xs sm:text-sm leading-4 font-semibold mt-3"> {item.datePresent} </span>
                                </div>
                                <div className= "flex flex-col justify-between items-center py-4 rounded-md bg-yellow-700">
                                    <span className="text-gray-300 text-xs sm:text-sm leading-4"> Days Late </span>
                                    <span className="text-gray-100 text-xs sm:text-sm leading-4 font-semibold mt-3"> {item.dateLate} </span>
                                </div>
                                <div className= "flex flex-col justify-between items-center py-4 rounded-md bg-red-800">
                                    <span className="text-gray-300 text-xs sm:text-sm leading-4"> Days Absent </span>
                                    <span className="text-gray-100 text-xs sm:text-sm leading-4 font-semibold mt-3"> {item.dateAbsent} </span>
                                </div>
                            </>
                        </div>
                    </animated.div>
                )})}
                </Card>
            </div>
        </>
    );

    const TermTwo = () => (
        <>
            <div className="w-full">
                <Card>
                    <div className="p-2 sm:p-4">
                        <div className="flex justify-between items-center">
                            <div className="flex text-gray-200 leading-4">
                                <span className="text-xs sm:text-sm mr-2 sm:mr-4"> {clickedSession} </span>
                                <span className='text-xs sm:text-sm w-16 sm:w-auto'> Second Term </span>
                            </div>
                            <div className="w-32 sm:w-40 rounded bg-blue-900 text-blue-100 text-xs font-semibold py-2 leading-4 text-center flex justify-center">
                                <Link to='/attendance'>
                                    View Attendance
                                </Link>
                            </div>
                        </div>
                        <div className="w-full mt-5 grid grid-cols-2 lg:grid-cols-4 col-gap-3 row-gap-3">
                            {secondTerm.map(item => {
                                const infoBgColor = classNames({
                                    "flex flex-col justify-between items-center py-4 rounded-md" : true,
                                    "bg-blue-800" : item.index === "1",
                                    "bg-green-800" : item.index === "2",
                                    "bg-yellow-700" : item.index === "3",
                                    "bg-red-800" : item.index === "4"
                                })
                                return (
                                <div key={item.index} className={infoBgColor}>
                                    <span className="text-gray-300 text-sm leading-4"> {item.info} </span>
                                    <span className="text-gray-100 text-sm leading-4 font-semibold mt-3"> {item.metric} </span>
                                </div>
                            )})}
                        </div>
                    </div>
                </Card>
            </div>
        </>
    );

    const transitionStyles = useSpring({
        to: [
            { opacity: 1, transform: 'translateX(0)' },
        ],
        from: { opacity: 0, transform: 'translateX(80px)' },
        config: { duration: 1000 }
    });

    return (
        <div className='px-4 sm:flex sm:px-0'>
            <div className="w-full sm:w-2/3">
                <animated.div style={transitionStyles}>
                    <PageNav Heading={Heading} PageSvg={pageSvg} />
                </animated.div>
                <div className="py-6 px-0 w-full">
                        <div className="flex ">
                            <span className="font-bold mr-4 mt-2 text-sm sm:text-base"> Show </span>
                            <div ref={sessionRef} className="flex flex-col relative">
                                <span onClick={()=> setDisplayDropdown(!displayDropdown)} className="w-28 sm:w-32 flex justify-between items-center p-2 bg-white rounded-md border border-gray-600 h-10 cursor-pointer">
                                    <span className="leading-4 text-xs text-gray-100 mr-3"> {clickedSession} </span>
                                    <span className="pt-1">
                                        <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.76959 5.78571C3.60464 6.07143 3.19224 6.07143 3.02729 5.78571L0.0580571 0.642857C-0.1069 0.357143 0.0992962 -2.8842e-08 0.429211 0L6.36767 5.19157e-07C6.69759 5.47999e-07 6.90378 0.357143 6.73882 0.642858L3.76959 5.78571Z" fill="#000114"/>
                                        </svg>
                                    </span>
                                </span>
                                <ul className={showDropdown}>
                                    { sessionAttendance.map((session) => (
                                        <li onClick={() => displaySessions(session)} className="p-2 hover:text-blue-200 text-xs rounded border-md border-gray-200 cursor-pointer transition ease-in-out duration-100"> 
                                            {session.year} 
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div ref={termRef} className="flex flex-col ml-3 relative">
                                <span onClick={()=> setDisplayTermDropdown(!displayTermDropdown)} className="w-28 sm:w-32 flex justify-between items-center p-2 bg-white rounded-md border border-gray-600 h-10 cursor-pointer">
                                    <span className="leading-4 text-xs text-gray-100 mr-3"> {clickedTermDropdown} </span>
                                    <span className="pt-1">
                                        <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.76959 5.78571C3.60464 6.07143 3.19224 6.07143 3.02729 5.78571L0.0580571 0.642857C-0.1069 0.357143 0.0992962 -2.8842e-08 0.429211 0L6.36767 5.19157e-07C6.69759 5.47999e-07 6.90378 0.357143 6.73882 0.642858L3.76959 5.78571Z" fill="#000114"/>
                                        </svg>
                                    </span>
                                </span>
                                <ul className={showTermDropdown}>
                                    { sessionTerms.map(term => (
                                        <li onClick={() => displayTerms(term)} className="p-2 hover:text-blue-200 text-xs rounded border-md border-gray-200 cursor-pointer transition ease-in-out duration-100"> 
                                            {(term.term)} 
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        {/* {firstTermAtt && 
                        <div className="mt-4">
                            <TermOne />
                        </div>}
                        {secondTermAtt && 
                        <div className="mt-4">
                            <TermTwo />
                        </div>} */}
                        {loading ? 
                        <div className='flex justify-center w-full my-24'>
                            <img src={loadingSpin} alt='loading...' />
                        </div> :
                        <>
                            {allTerms ? 
                            <div className="mt-4">
                                <div className="mt-4">
                                    <TermOne />
                                </div>
                            </div>
                            : 
                            <div className="mt-8 mx-auto w-64">
                                <Card>
                                    <div className='block text-center w-full p-6'>
                                        <FontAwesomeIcon icon={faBan} className='text-red-100'/>
                                        <div className='text-xs sm:text-sm text-red-300 font-semibold'>
                                            Oops! {errorMessage}
                                        </div>
                                        <div className='text-center text-blue-200 cursor-pointer mt-4'> 
                                            <span className='hover:text-blue-300 hover:underline' onClick={() => window.location.reload()}>
                                            Try refresh 
                                            </span>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                            }
                        </>}
                    </div>
            </div>
            <div className="w-full sm:w-1/3 sm:mx-4 mt-6">
                <Featured />
            </div>
        </div>
    )
}

export default VirtualClassroom;